import { CommonSuccessResponse } from "constants/types/common";
import {
  InventoryAllItemType,
  InventoryParamsType,
  InventoryResponseType,
} from "constants/types/inventory";
import { useMemo } from "react";
import useSWR from "swr";
import { serialize } from "utils/validation/string";

export const getInventoryListKey = (params?: InventoryParamsType) => {
  return `/inventory?${serialize({ ...params })}`;
};

export const useInventories = (params?: InventoryParamsType) => {
  const {
    data,
    error,
    isLoading,
    mutate,
  }: {
    data: CommonSuccessResponse<InventoryResponseType[]> | undefined;
    error: any;
    isLoading: boolean;
    mutate: any;
  } = useSWR(getInventoryListKey(params), { refreshInterval: 0 });

  const pagination = data?.meta;
  const inventories = data?.data;

  return {
    inventories,
    pagination,
    error,
    isLoading,
    mutate,
  };
};

export const useListInventory = () => {
  const {
    data,
    error,
    isLoading,
    mutate,
  }: {
    data: CommonSuccessResponse<InventoryAllItemType[]> | undefined;
    error: any;
    isLoading: boolean;
    mutate: any;
  } = useSWR("/inventory/all", { refreshInterval: 0 });

  const inventories = data?.data ?? [];

  const inventoryMap = useMemo(
    () =>
      inventories.reduce<Record<string, InventoryAllItemType>>(
        (acc, inventory) => {
          acc[inventory.id] = inventory;
          return acc;
        },
        {},
      ),
    [inventories],
  );

  return {
    inventories,
    inventoryMap,
    error,
    isLoading,
    mutate,
  };
};
